import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'
import moment from 'moment'

const urlContrato = '/service/materiais/contrato/'

class ConsultaContratoService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
        const adms = config.adms ? config.adms : []
        this.state = {
            adms: adms,
        }
    }

    consultar(filtro) {
        let data = {
            administracao: filtro.administracao.length > 0 ? filtro.administracao.map(e => e.value) : this.state.adms,
            tipo: filtro.tipoContrato ? filtro.tipoContrato.map(e => e.value) : '',
            exercicio: filtro.exercicioContrato,
            numero: filtro.numeroContrato,
            objeto: filtro.objetoContrato,
            nomeContratado: filtro.nomeContratadoContrato,
            cpf: filtro.cpf ? filtro.cpf.replace(/^(\d{3}).(\d{3}).(\d{3})-(\d{2})/, '$1$2$3$4') : null,
            cnpj: filtro.cnpj ? filtro.cnpj.replace(/^(\d{2}).(\d{3}).(\d{3})\/(\d{4})-(\d{2})/, '$1$2$3$4$5') : null,
            modalidade: filtro.modalidade ? filtro.modalidade.map(e => e.value) : '',
            tipoCompra: filtro.tipoCompra ? filtro.tipoCompra.value : null,
            dataValidadeFinalInicio: filtro.dataValidadeInicial ? moment(filtro.dataValidadeInicial).format('YYYY-MM-DD') : '',
            dataValidadeFinalFim: filtro.dataValidadeFinal ? moment(filtro.dataValidadeFinal).format('YYYY-MM-DD') : '',
            situacao: filtro.situacao ? filtro.situacao.value : '',
        }

        return this.conex.post(urlContrato + 'consultarContrato/', JSON.stringify(data))
    }

    consultarPorLicitacao(filtro) {
        let data = {
            numero: filtro.numeroTotal,
        }

        return this.conex.post(urlContrato + 'recuperarContratoLicitacao/', JSON.stringify(data))
    }
}

export default ConsultaContratoService
